@if (isOrgUser()) {
@if (share?.checkInData?.checkInTime) {
<div sxCol sxGap="10px" sxBackground="light" sxBorderColor="one" sxBorderWidth="1px" sxRadius="medium"
     sxPadding="medium">
  <div sxRow sxDistribution="spaceBetween" sxAlign="center" sxGap="10px">
    <div sxWidth="50px" sxHeight="50px" sxRadius="small"
         sxCenterize="col" sxBackground="base" sxColor="two">
      @if (stayDuration) {
      <p sxMargin="0" sxTextSize="22px" sxTextWeight="bold">{{stayDuration}}</p>
      <p sxMargin="0" sxTextSize="10px">{{stayDuration > 1 ? 'days' : 'day'}}</p>
      } @else {
      <ion-icon sxTextSize="30px" name="calendar-clear-outline"></ion-icon>
      }
    </div>
    <div sxCol sxWidth="fill">
      <div class="flex items-center justify-start gap-2">
        <p class="text-sm text-gray-600">Check In</p>
        @if (!share?.checkInData?.checkOutTime) {
        <p (click)="onEditCheckInClicked()" class="underline cursor-pointer text-xs text-gray-500">
          Edit
        </p>
        }
      </div>
      <div sxRow sxAlign="center" sxGap="5px">
        <p sxMargin="0">{{share?.checkInData?.checkInTime | date : 'mediumDate'}}</p>
      </div>
    </div>
    <div sxCol sxWidth="fill" sxBorderColor="one" sxBorderWidth="0 0 0 1px" sxPadding="0 0 0 10px">
      @if (share?.checkInData?.checkOutTime) {
      <div>
        <p sxMargin="0 0 5px" sxTextSize="12px" sxColor="two" sxTextWeight="bold">Check Out</p>
        <p sxMargin="0">{{share?.checkInData?.checkOutTime | date : 'mediumDate'}}</p>
      </div>
      } @else {
      <button sxBorderColor="one" sxBorderWidth="1px"
              sxGap="5px" sxPadding="10px" sxRadius="small" sxCenterize="row" sxBackground="light" sxColor="three"
              sxTextSize="16px" (click)="onCheckOutClicked()">
        Check out
        <ion-icon sxTextSize="14px" name="log-out-outline"></ion-icon>
      </button>
      }
    </div>
  </div>
  @if (share?.checkInData?.remark?.length > 0) {
  <div sxBorderWidth="1px 0 0" sxBorderColor="one" sxPadding="5px 0 0">
    <p sxMargin="0" sxTextSize="small" sxColor="two"><span>Check Out Remark:</span> {{share?.checkInData?.remark}}</p>
  </div>
  }
</div>
} @else {
  <div sxRow sxAlign="center" sxDistribution="spaceBetween" sxBackground="light" sxBorderColor="one"
       sxBorderWidth="1px" sxRadius="medium" sxPadding="medium">
    <p sxMargin="0">Mark as Checked-in</p>
    <button type="button" class="flex h-10 w-10 items-center justify-center rounded-full bg-zinc-900 text-white border-0 cursor-pointer"
            (click)="onEditCheckInClicked()">
      <ion-icon name="arrow-forward-outline"></ion-icon>
    </button>
  </div>
}
}
